(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nmr-home-event-products"] && !Shopify.designMode) return;
  try {
    
/* NMR MINIMAL EVENT PRODUCT RAIL R51 */
(() => {
  const ROOT = '[data-nmr-event-products]';

  function bind(section) {
    if (!section || section.dataset.nmrEventRailBound === 'true') return;

    const rail = section.querySelector('.nmr-home-event-products__product-list');
    const prev = section.querySelector('[data-nmr-event-prev]');
    const next = section.querySelector('[data-nmr-event-next]');

    if (!rail || (!prev && !next)) return;

    section.dataset.nmrEventRailBound = 'true';

    function step() {
      const cards = rail.querySelectorAll('.nmr-product-card');

      if (!cards.length) {
        return Math.max(220,rail.clientWidth * .7);
      }

      if (cards.length > 1) {
        const delta = cards[1].offsetLeft - cards[0].offsetLeft;

        if (Number.isFinite(delta) && Math.abs(delta) > 1) {
          return Math.abs(delta);
        }
      }

      const styles = getComputedStyle(rail);
      const gap = Number.parseFloat(
        styles.columnGap || styles.gap || '0'
      ) || 0;

      return cards[0].getBoundingClientRect().width + gap;
    }

    function move(direction) {
      rail.scrollBy({
        left:direction * step(),
        behavior:'smooth'
      });
    }

    prev?.addEventListener('click',() => move(-1));
    next?.addEventListener('click',() => move(1));
  }

  function init(root = document) {
    if (root.matches?.(ROOT)) bind(root);
    root.querySelectorAll?.(ROOT).forEach(bind);
  }

  init();

  document.addEventListener('shopify:section:load',(event) => {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmr-home-most-viewed"] && !Shopify.designMode) return;
  try {
    
/* NMR MOST VIEWED COMPOSITOR LOOP R48 */
(() => {
  const ROOT = '[data-nmr-showcase-motion]';

  const clamp = (value,min,max) =>
    Math.min(max,Math.max(min,value));

  function bind(section) {
    if (!section || section.dataset.nmrMotionBound === 'true') return;

    const viewport = section.querySelector('[data-nmr-motion-rail]');
    const leftButton = section.querySelector('[data-nmr-motion-left]');
    const rightButton = section.querySelector('[data-nmr-motion-right]');

    if (!viewport) return;

    const originals = Array.from(viewport.children)
      .filter((item) => item.matches('.nmr-product-card'));

    if (originals.length < 2) return;

    section.dataset.nmrMotionBound = 'true';
    section.dataset.nmrMotionRuntime = 'compositor-loop-ready';
    section.dataset.nmrMotionState = 'running';

    const autoplay =
      section.dataset.nmrShowcaseAutoplay !== 'false';

    const requestedSpeed =
      Number.parseFloat(
        section.dataset.nmrShowcaseSpeed || '26'
      );

    const speed =
      Number.isFinite(requestedSpeed)
        ? clamp(requestedSpeed,8,60)
        : 26;

    const track =
      document.createElement('div');

    track.className =
      'nmr-home-showcase__motion-track';

    const beforeFragment =
      document.createDocumentFragment();

    const originalFragment =
      document.createDocumentFragment();

    const afterFragment =
      document.createDocumentFragment();

    originals.forEach((item) => {
      const beforeClone =
        item.cloneNode(true);

      const afterClone =
        item.cloneNode(true);

      beforeClone.dataset.nmrLoopClone =
        'before';

      afterClone.dataset.nmrLoopClone =
        'after';

      item.dataset.nmrLoopOriginal =
        'true';

      beforeFragment.appendChild(
        beforeClone
      );

      originalFragment.appendChild(
        item
      );

      afterFragment.appendChild(
        afterClone
      );
    });

    track.appendChild(
      beforeFragment
    );

    track.appendChild(
      originalFragment
    );

    track.appendChild(
      afterFragment
    );

    viewport.replaceChildren(
      track
    );

    let cycle =
      1;

    let position =
      1;

    let direction =
      1;

    let velocity =
      speed;

    let lastTime =
      0;

    let frameId =
      0;

    let hoverPaused =
      false;

    let focusPaused =
      false;

    let dragging =
      false;

    let dragActivated =
      false;

    let dragStartX =
      0;

    let dragStartPosition =
      0;

    let suppressClickUntil =
      0;

    let interactionUntil =
      0;

    let manualMotion =
      null;

    let resizeTimer =
      0;

    function measureCycle() {
      const firstOriginal =
        track.querySelector(
          '[data-nmr-loop-original="true"]'
        );

      const firstAfter =
        track.querySelector(
          '[data-nmr-loop-clone="after"]'
        );

      if (
        !firstOriginal ||
        !firstAfter
      ) {
        return Math.max(
          1,
          track.scrollWidth / 3
        );
      }

      const measured =
        firstAfter.offsetLeft -
        firstOriginal.offsetLeft;

      return Math.max(
        1,
        measured
      );
    }

    function normalize(value) {
      while (
        value >=
        cycle * 2
      ) {
        value -= cycle;
      }

      while (
        value <
        cycle
      ) {
        value += cycle;
      }

      return value;
    }

    function render() {
      track.style.transform =
        'translate3d(' +
        (-position).toFixed(3) +
        'px,0,0)';
    }

    function setState(state) {
      if (
        section.dataset.nmrMotionState !== state
      ) {
        section.dataset.nmrMotionState =
          state;
      }
    }

    function paused(time) {
      return (
        hoverPaused ||
        focusPaused ||
        time < interactionUntil
      );
    }

    function cardStep() {
      const first =
        track.querySelector(
          '[data-nmr-loop-original="true"]'
        );

      const second =
        first?.nextElementSibling;

      if (
        first &&
        second
      ) {
        const step =
          second.offsetLeft -
          first.offsetLeft;

        if (
          Number.isFinite(step) &&
          step > 0
        ) {
          return step;
        }
      }

      return Math.max(
        1,
        cycle / originals.length
      );
    }

    function beginManual(cards) {
      const now =
        performance.now();

      const delta =
        cardStep() * cards;

      manualMotion = {
        start:position,
        delta,
        started:now,
        duration:420
      };

      interactionUntil =
        now + 500;

      direction =
        cards < 0
          ? -1
          : 1;

      velocity = 0;

      setState('manual');
    }

    function runManual(time) {
      if (!manualMotion) return false;

      const elapsed =
        time -
        manualMotion.started;

      const t =
        clamp(
          elapsed /
          manualMotion.duration,
          0,
          1
        );

      const eased =
        1 -
        Math.pow(
          1 - t,
          4
        );

      position =
        normalize(
          manualMotion.start +
          (
            manualMotion.delta *
            eased
          )
        );

      render();

      if (t >= 1) {
        manualMotion = null;

        velocity =
          direction *
          speed *
          .55;

        interactionUntil =
          time + 180;
      }

      return true;
    }

    function animate(time) {
      frameId =
        requestAnimationFrame(
          animate
        );

      if (!lastTime) {
        lastTime = time;
        render();
        return;
      }

      const dt =
        Math.min(
          34,
          time - lastTime
        );

      lastTime =
        time;

      if (
        !autoplay ||
        document.hidden
      ) {
        velocity = 0;

        setState(
          document.hidden
            ? 'hidden'
            : 'disabled'
        );

        return;
      }

      if (runManual(time)) {
        return;
      }

      if (dragging) {
        velocity = 0;
        setState('dragging');
        return;
      }

      const isPaused =
        paused(time);

      const targetVelocity =
        isPaused
          ? 0
          : direction * speed;

      const timeConstant =
        isPaused
          ? 115
          : 420;

      const ease =
        1 -
        Math.exp(
          -dt /
          timeConstant
        );

      velocity +=
        (
          targetVelocity -
          velocity
        ) * ease;

      if (
        isPaused &&
        Math.abs(velocity) < .02
      ) {
        velocity = 0;
      }

      position +=
        velocity *
        dt /
        1000;

      position =
        normalize(
          position
        );

      render();

      setState(
        isPaused
          ? 'paused'
          : 'running'
      );
    }

    leftButton?.addEventListener(
      'click',
      () => beginManual(-1)
    );

    rightButton?.addEventListener(
      'click',
      () => beginManual(1)
    );

    viewport.addEventListener(
      'mouseenter',
      () => {
        hoverPaused = true;
        setState('hover-paused');
      }
    );

    viewport.addEventListener(
      'mouseleave',
      () => {
        hoverPaused = false;
        setState('running');
      }
    );

    viewport.addEventListener(
      'focusin',
      () => {
        focusPaused = true;
        setState('focus-paused');
      }
    );

    viewport.addEventListener(
      'focusout',
      () => {
        focusPaused = false;
      }
    );

    viewport.addEventListener(
      'pointerdown',
      (event) => {
        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) {
          return;
        }

        dragging = true;
        dragActivated = false;

        dragStartX =
          event.clientX;

        dragStartPosition =
          position;

        velocity = 0;

        viewport.setPointerCapture?.(
          event.pointerId
        );
      },
      {passive:true}
    );

    viewport.addEventListener(
      'pointermove',
      (event) => {
        if (!dragging) return;

        const dx =
          event.clientX -
          dragStartX;

        if (
          !dragActivated &&
          Math.abs(dx) > 6
        ) {
          dragActivated = true;
          setState('dragging');
        }

        if (!dragActivated) return;

        position =
          normalize(
            dragStartPosition -
            dx
          );

        render();
      },
      {passive:true}
    );

    function endDrag(event) {
      if (!dragging) return;

      dragging = false;

      viewport.releasePointerCapture?.(
        event.pointerId
      );

      if (dragActivated) {
        suppressClickUntil =
          performance.now() + 280;

        direction =
          position >= dragStartPosition
            ? 1
            : -1;
      }

      dragActivated = false;

      interactionUntil =
        performance.now() + 260;

      velocity =
        direction *
        speed *
        .34;
    }

    viewport.addEventListener(
      'pointerup',
      endDrag,
      {passive:true}
    );

    viewport.addEventListener(
      'pointercancel',
      endDrag,
      {passive:true}
    );

    viewport.addEventListener(
      'click',
      (event) => {
        if (
          performance.now() <
          suppressClickUntil
        ) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    function resizePreservingPhase() {
      const oldCycle =
        cycle;

      const phase =
        oldCycle > 0
          ? (
              (
                position -
                oldCycle
              ) %
              oldCycle +
              oldCycle
            ) %
            oldCycle /
            oldCycle
          : 0;

      cycle =
        measureCycle();

      position =
        cycle +
        (
          phase *
          cycle
        );

      render();
    }

    const observer =
      'ResizeObserver' in window
        ? new ResizeObserver(() => {
            window.clearTimeout(
              resizeTimer
            );

            resizeTimer =
              window.setTimeout(
                resizePreservingPhase,
                90
              );
          })
        : null;

    observer?.observe(
      viewport
    );

    observer?.observe(
      track
    );

    cycle =
      measureCycle();

    position =
      cycle;

    render();

    frameId =
      requestAnimationFrame(
        animate
      );
  }

  function init(root = document) {
    if (root.matches?.(ROOT)) {
      bind(root);
    }

    root
      .querySelectorAll?.(ROOT)
      .forEach(bind);
  }

  init();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      init(event.target);
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmr-home-product-showcase"] && !Shopify.designMode) return;
  try {
    
/* NMR MOST VIEWED COMPOSITOR LOOP R48 */
(() => {
  const ROOT = '[data-nmr-showcase-motion]';

  const clamp = (value,min,max) =>
    Math.min(max,Math.max(min,value));

  function bind(section) {
    if (!section || section.dataset.nmrMotionBound === 'true') return;

    const viewport = section.querySelector('[data-nmr-motion-rail]');
    const leftButton = section.querySelector('[data-nmr-motion-left]');
    const rightButton = section.querySelector('[data-nmr-motion-right]');

    if (!viewport) return;

    const originals = Array.from(viewport.children)
      .filter((item) => item.matches('.nmr-product-card'));

    if (originals.length < 2) return;

    section.dataset.nmrMotionBound = 'true';
    section.dataset.nmrMotionRuntime = 'compositor-loop-ready';
    section.dataset.nmrMotionState = 'running';

    const autoplay =
      section.dataset.nmrShowcaseAutoplay !== 'false';

    const requestedSpeed =
      Number.parseFloat(
        section.dataset.nmrShowcaseSpeed || '26'
      );

    const speed =
      Number.isFinite(requestedSpeed)
        ? clamp(requestedSpeed,8,60)
        : 26;

    const track =
      document.createElement('div');

    track.className =
      'nmr-home-showcase__motion-track';

    const beforeFragment =
      document.createDocumentFragment();

    const originalFragment =
      document.createDocumentFragment();

    const afterFragment =
      document.createDocumentFragment();

    originals.forEach((item) => {
      const beforeClone =
        item.cloneNode(true);

      const afterClone =
        item.cloneNode(true);

      beforeClone.dataset.nmrLoopClone =
        'before';

      afterClone.dataset.nmrLoopClone =
        'after';

      item.dataset.nmrLoopOriginal =
        'true';

      beforeFragment.appendChild(
        beforeClone
      );

      originalFragment.appendChild(
        item
      );

      afterFragment.appendChild(
        afterClone
      );
    });

    track.appendChild(
      beforeFragment
    );

    track.appendChild(
      originalFragment
    );

    track.appendChild(
      afterFragment
    );

    viewport.replaceChildren(
      track
    );

    let cycle =
      1;

    let position =
      1;

    let direction =
      1;

    let velocity =
      speed;

    let lastTime =
      0;

    let frameId =
      0;

    let hoverPaused =
      false;

    let focusPaused =
      false;

    let dragging =
      false;

    let dragActivated =
      false;

    let dragStartX =
      0;

    let dragStartPosition =
      0;

    let suppressClickUntil =
      0;

    let interactionUntil =
      0;

    let manualMotion =
      null;

    let resizeTimer =
      0;

    function measureCycle() {
      const firstOriginal =
        track.querySelector(
          '[data-nmr-loop-original="true"]'
        );

      const firstAfter =
        track.querySelector(
          '[data-nmr-loop-clone="after"]'
        );

      if (
        !firstOriginal ||
        !firstAfter
      ) {
        return Math.max(
          1,
          track.scrollWidth / 3
        );
      }

      const measured =
        firstAfter.offsetLeft -
        firstOriginal.offsetLeft;

      return Math.max(
        1,
        measured
      );
    }

    function normalize(value) {
      while (
        value >=
        cycle * 2
      ) {
        value -= cycle;
      }

      while (
        value <
        cycle
      ) {
        value += cycle;
      }

      return value;
    }

    function render() {
      track.style.transform =
        'translate3d(' +
        (-position).toFixed(3) +
        'px,0,0)';
    }

    function setState(state) {
      if (
        section.dataset.nmrMotionState !== state
      ) {
        section.dataset.nmrMotionState =
          state;
      }
    }

    function paused(time) {
      return (
        hoverPaused ||
        focusPaused ||
        time < interactionUntil
      );
    }

    function cardStep() {
      const first =
        track.querySelector(
          '[data-nmr-loop-original="true"]'
        );

      const second =
        first?.nextElementSibling;

      if (
        first &&
        second
      ) {
        const step =
          second.offsetLeft -
          first.offsetLeft;

        if (
          Number.isFinite(step) &&
          step > 0
        ) {
          return step;
        }
      }

      return Math.max(
        1,
        cycle / originals.length
      );
    }

    function beginManual(cards) {
      const now =
        performance.now();

      const delta =
        cardStep() * cards;

      manualMotion = {
        start:position,
        delta,
        started:now,
        duration:420
      };

      interactionUntil =
        now + 500;

      direction =
        cards < 0
          ? -1
          : 1;

      velocity = 0;

      setState('manual');
    }

    function runManual(time) {
      if (!manualMotion) return false;

      const elapsed =
        time -
        manualMotion.started;

      const t =
        clamp(
          elapsed /
          manualMotion.duration,
          0,
          1
        );

      const eased =
        1 -
        Math.pow(
          1 - t,
          4
        );

      position =
        normalize(
          manualMotion.start +
          (
            manualMotion.delta *
            eased
          )
        );

      render();

      if (t >= 1) {
        manualMotion = null;

        velocity =
          direction *
          speed *
          .55;

        interactionUntil =
          time + 180;
      }

      return true;
    }

    function animate(time) {
      frameId =
        requestAnimationFrame(
          animate
        );

      if (!lastTime) {
        lastTime = time;
        render();
        return;
      }

      const dt =
        Math.min(
          34,
          time - lastTime
        );

      lastTime =
        time;

      if (
        !autoplay ||
        document.hidden
      ) {
        velocity = 0;

        setState(
          document.hidden
            ? 'hidden'
            : 'disabled'
        );

        return;
      }

      if (runManual(time)) {
        return;
      }

      if (dragging) {
        velocity = 0;
        setState('dragging');
        return;
      }

      const isPaused =
        paused(time);

      const targetVelocity =
        isPaused
          ? 0
          : direction * speed;

      const timeConstant =
        isPaused
          ? 115
          : 420;

      const ease =
        1 -
        Math.exp(
          -dt /
          timeConstant
        );

      velocity +=
        (
          targetVelocity -
          velocity
        ) * ease;

      if (
        isPaused &&
        Math.abs(velocity) < .02
      ) {
        velocity = 0;
      }

      position +=
        velocity *
        dt /
        1000;

      position =
        normalize(
          position
        );

      render();

      setState(
        isPaused
          ? 'paused'
          : 'running'
      );
    }

    leftButton?.addEventListener(
      'click',
      () => beginManual(-1)
    );

    rightButton?.addEventListener(
      'click',
      () => beginManual(1)
    );

    viewport.addEventListener(
      'mouseenter',
      () => {
        hoverPaused = true;
        setState('hover-paused');
      }
    );

    viewport.addEventListener(
      'mouseleave',
      () => {
        hoverPaused = false;
        setState('running');
      }
    );

    viewport.addEventListener(
      'focusin',
      () => {
        focusPaused = true;
        setState('focus-paused');
      }
    );

    viewport.addEventListener(
      'focusout',
      () => {
        focusPaused = false;
      }
    );

    viewport.addEventListener(
      'pointerdown',
      (event) => {
        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) {
          return;
        }

        dragging = true;
        dragActivated = false;

        dragStartX =
          event.clientX;

        dragStartPosition =
          position;

        velocity = 0;

        viewport.setPointerCapture?.(
          event.pointerId
        );
      },
      {passive:true}
    );

    viewport.addEventListener(
      'pointermove',
      (event) => {
        if (!dragging) return;

        const dx =
          event.clientX -
          dragStartX;

        if (
          !dragActivated &&
          Math.abs(dx) > 6
        ) {
          dragActivated = true;
          setState('dragging');
        }

        if (!dragActivated) return;

        position =
          normalize(
            dragStartPosition -
            dx
          );

        render();
      },
      {passive:true}
    );

    function endDrag(event) {
      if (!dragging) return;

      dragging = false;

      viewport.releasePointerCapture?.(
        event.pointerId
      );

      if (dragActivated) {
        suppressClickUntil =
          performance.now() + 280;

        direction =
          position >= dragStartPosition
            ? 1
            : -1;
      }

      dragActivated = false;

      interactionUntil =
        performance.now() + 260;

      velocity =
        direction *
        speed *
        .34;
    }

    viewport.addEventListener(
      'pointerup',
      endDrag,
      {passive:true}
    );

    viewport.addEventListener(
      'pointercancel',
      endDrag,
      {passive:true}
    );

    viewport.addEventListener(
      'click',
      (event) => {
        if (
          performance.now() <
          suppressClickUntil
        ) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    function resizePreservingPhase() {
      const oldCycle =
        cycle;

      const phase =
        oldCycle > 0
          ? (
              (
                position -
                oldCycle
              ) %
              oldCycle +
              oldCycle
            ) %
            oldCycle /
            oldCycle
          : 0;

      cycle =
        measureCycle();

      position =
        cycle +
        (
          phase *
          cycle
        );

      render();
    }

    const observer =
      'ResizeObserver' in window
        ? new ResizeObserver(() => {
            window.clearTimeout(
              resizeTimer
            );

            resizeTimer =
              window.setTimeout(
                resizePreservingPhase,
                90
              );
          })
        : null;

    observer?.observe(
      viewport
    );

    observer?.observe(
      track
    );

    cycle =
      measureCycle();

    position =
      cycle;

    render();

    frameId =
      requestAnimationFrame(
        animate
      );
  }

  function init(root = document) {
    if (root.matches?.(ROOT)) {
      bind(root);
    }

    root
      .querySelectorAll?.(ROOT)
      .forEach(bind);
  }

  init();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      init(event.target);
    }
  );
})();

  } catch(e) { console.error(e); }
})();
})();
